import { baseApi } from "../api/baseApi";
import {
  CurrentQueueDetailSearchRequest,
  CurrentQueueDetailSearchResponse,
  SalesSummaryQuery,
  SalesSummaryResponse,
} from "../types/currentQueueDetail.types";

export type {
  CurrentQueueDetailItem,
  CurrentQueueDetailSearchRequest,
  CurrentQueueDetailSearchResponse,
  SalesSummaryByCampaign,
  SalesSummaryCampaignByType,
  SalesSummaryCustomer,
  SalesSummaryQuery,
  SalesSummaryResponse,
} from "../types/currentQueueDetail.types";

export {
  BrazeCurrentEventType,
  BrazeCurrentEventTypeLabels,
} from "../types/currentQueueDetail.types";

export const currentQueueDetailApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSalesSummary: builder.query<SalesSummaryResponse, SalesSummaryQuery>({
      query: (body) => ({
        url: `/v1/currentqueuedetails/sales/summary`,
        method: "POST",
        body,
      }),
      providesTags: ["MyContacts"],
    }),
    searchCurrentQueueDetails: builder.query<
      CurrentQueueDetailSearchResponse,
      CurrentQueueDetailSearchRequest
    >({
      query: (body) => ({
        url: `/v1/currentqueuedetails/search`,
        method: "POST",
        body,
      }),
      providesTags: ["MyContacts"],
    }),
  }),
});

export const {
  useGetSalesSummaryQuery,
  useSearchCurrentQueueDetailsQuery,
} = currentQueueDetailApi;
